import * as React from 'react';
import './style.scss';
import { ServiceItemProps } from './ServiceItemProps';
import { useSpatz, MetricParam } from '@app/hooks/useSpatz';

const ServiceItem: React.FC<ServiceItemProps> = ({ service }) => {
  const { sendSpatzStats } = useSpatz({
    Services: { catalog: { Главная: {} } },
  });

  const clickHandler = (e: React.MouseEvent) => {
    e.preventDefault();
    const data: MetricParam = {
      'клик на услугу': {
        click: {
          [service.title]: {
            [`online: ${service.isElectronic ? 1 : 0}`]: {
              is_new: '0',
              is_hit: '0',
            },
          },
        },
      },
    };

    sendSpatzStats(data);
    window.location.href = service.url || '';
  };

  const mouseUpHandler = (e: React.MouseEvent) => {
    if (e.button === 1) {
      e.preventDefault();
      window.open(service.url!);
    }
  };

  return (
    <a
      href={service.url || ''}
      className="mos-service-item"
      data-testid="serviceItem"
      target="_self"
      aria-label={`Услуга ${service.title}`}
      onClick={clickHandler}
      onMouseUp={mouseUpHandler}
    >
      {service.isElectronic && !service.isPopularGlobal && (
        <div className="mos-service-item_label">онлайн</div>
      )}
      {service.marks &&
        !service.isPopularGlobal &&
        service.marks.map((mark) => (
          <div
            key={mark.id}
            className={`mos-service-item_label mos-service-item_label-${mark.code}`}
          >
            {mark.title}
          </div>
        ))}
      <div className="mos-service-item_title">{service.title}</div>
    </a>
  );
};

export default ServiceItem;
